import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const productQuery = graphql(/* GraphQL */ `
    query Product($productCode: String!, $userRegistrationRegion: String) {
        product(productCode: $productCode, userRegistrationRegion: $userRegistrationRegion) {
            billingVendorProductCode
            planType
            planTier
            title
            productCode
            price
            trial
            trialInterval
            trialUnit
        }
    }
`);
